/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_2_AInputs */

const en_mk_faq_2_a = /** @type {(inputs: Mk_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Our internal model gateway doesn't store conversation content and doesn't use it to train anyone's model.`)
};

const id_mk_faq_2_a = /** @type {(inputs: Mk_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak. Gateway model internal kami tidak menyimpan konten percakapan dan tidak memakainya untuk melatih model pihak mana pun.`)
};

/**
* | output |
* | --- |
* | "No. Our internal model gateway doesn't store conversation content and doesn't use it to train anyone's model." |
*
* @param {Mk_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_2_a = /** @type {((inputs?: Mk_Faq_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_2_a(inputs)
	return en_mk_faq_2_a(inputs)
});